"use client";

import { useSelectedLayoutSegment } from "next/navigation";
import type { ReactNode } from "react";

/**
 * Re-mounts its children whenever the active route segment changes,
 * which makes the existing `cs-reveal` fade-up animation play on every
 * tab/segment swap. The outer wrapper itself is stable so layout and
 * scroll position survive across navigations.
 *
 * Drop this between a layout and its `{children}` to give a section
 * with sub-routes (e.g. /climate, /water) a consistent route-change
 * fade without each route having to opt in.
 */
export function RouteFade({ children }: { children: ReactNode }) {
  const segment = useSelectedLayoutSegment() ?? "_index";
  return (
    <div key={segment} className="cs-reveal">
      {children}
    </div>
  );
}
